type AuthErrorLike = { code?: string; name?: string; status?: number; message?: string };

const messages: Record<string, string> = {
  invalid_credentials: "That email and password don’t match. Check them and try again.",
  email_not_confirmed: "Confirm your email first. Check your inbox for the link we sent.",
  user_already_exists: "There’s already an account with that email. Try logging in.",
  email_exists: "There’s already an account with that email. Try logging in.",
  weak_password: "Choose a stronger password, with at least 6 characters.",
  same_password: "Choose a password you haven’t used here before.",
  email_address_invalid: "Enter a valid email address.",
  validation_failed: "Check your email and password, then try again.",
  over_email_send_rate_limit: "We’ve sent a few emails already. Wait a minute, then try again.",
  over_request_rate_limit: "Too many attempts. Wait a minute, then try again.",
  provider_disabled: "That sign-in option isn’t available yet. Use your email instead.",
  oauth_provider_not_supported: "That sign-in option isn’t available yet. Use your email instead.",
  provider_email_needs_verification: "Verify your email with the provider, then try again.",
  signup_disabled: "Sign-ups are paused right now. Try again soon.",
};

/** A sentence a person can act on, for any Supabase Auth error. */
export const authErrorMessage = (error: AuthErrorLike): string => {
  if (error.code && messages[error.code]) return messages[error.code];
  if (error.name === "AuthRetryableFetchError" || error.status === 0)
    return "We couldn’t reach Hazumu. Check your connection and try again.";
  return "Something went wrong. Try again in a moment.";
};
